/**
 * @generated SignedSource<<87dea15730e27a4cf0d13f37220d95de>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsContainer_item$data = {
  readonly isSold: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpRespSimilarItemsContainer_item";
};
export type PdpRespSimilarItemsContainer_item$key = {
  readonly " $data"?: PdpRespSimilarItemsContainer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsContainer_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsContainer_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "003dd6f801c2970770a4e76f447c39ef";

export default node;
